(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/betslip-footer.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/betslip-footer.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.BetslipFooter = Backbone.Model.extend({
    defaults: {
      price: 1,
      nrOfHalfHedges: 0,
      nrOfFullHedges: 0,
      system: null,
      tooManyHalfHedges: false,
      tooManyFullHedges: false,
      rowPrice: 1,
      numWeeks: 1,
      accountBalance: 0
    },

    initialize: function() {
      var competitionMode =
        svs.tipset.models.competition &&
          svs.tipset.models.competition.getCompetitionMode()
          ? svs.tipset.models.competition.getCompetitionMode()
          : false,
        self = this;
      this.set('isInCompetitionMode', competitionMode, { silent: true });

      this.listenTo(svs.tipset.collections.matchlist, 'buttonBet', this.update);
      this.listenTo(svs.tipset.models.systems, 'change', this.update);
      this.listenTo(
        svs.tipset.models.sportkryss,
        'sportkryssUpdated',
        this.update
      );
      this.listenTo(
        svs.tipset.models.weekPicker,
        'nrOfWeeksUpdated',
        this.update
      );
      this.listenTo(
        svs.tipset.models.betslipExpanded,
        'change:amount',
        this.update
      );
      this.listenTo(
        svs.tipset.models.bombenXperten,
        'bombenSet bombenRemoved',
        this.update
      );
      this.listenTo(
        svs.tipset.models.reduceFreeContainer,
        'change:rows',
        this.update
      );
      this.listenTo(svs.tipset.models.play, 'change', this.update);

      svs.components.account_balance.get(function(balance) {
        self.set(
          'accountBalance',
          balance != null ? svs.utils.format.Currency(balance) : null
        );
        self.set(
          'userAccountBalace',
          balance != null ? svs.utils.format.Currency(balance) : null
        );
        self.update();
      });

      svs.components.account_balance.on('change', this.setAccountBalance, this);

      this.update();
    },

    setAccountBalance: function(balance) {
      this.set(
        'accountBalance',
        balance != null ? svs.utils.format.Currency(balance) : null
      );
      this.update();
    },

    validateSystem: function(nrOfHalfHedges, nrOfFullHedges, system) {
      var tooManyHalfHedges = nrOfHalfHedges > system.half,
        tooManyFullHedges = nrOfFullHedges > system.full;
      this.set('tooManyHalfHedges', tooManyHalfHedges, { silent: true });
      this.set('tooManyFullHedges', tooManyFullHedges, { silent: true });
    },

    update: function() {
      var nrOfHalfHedges =
        svs.tipset.collections.matchlist.getNrOfHalfHedges() || 0,
        nrOfFullHedges =
          svs.tipset.collections.matchlist.getNrOfFullHedges() || 0,
        system = svs.tipset.models.systems.getCurrentSystem(),
        price = this.getPrice(),
        isPayable = this.isPayable();

      if (system) {
        this.validateSystem(nrOfHalfHedges, nrOfFullHedges, system);
      }

      this.set({
        nrOfHalfHedges: nrOfHalfHedges,
        nrOfFullHedges: nrOfFullHedges,
        system: system,
        price: price,
        isPayable: isPayable
      });
    },

    getPrice: function() {
      var system = svs.tipset.models.systems.getCurrentSystem(),
        nrOfRows = svs.tipset.collections.matchlist.getNrOfRows(),
        price = 0,
        sportkryssAmount =
          svs.tipset.models.gameDefinitions.hasSportkryss() &&
            svs.utils.ns.isNamespace('svs.tipset.models.sportkryss')
            ? svs.tipset.models.sportkryss.get('sportkryssAmount')
            : 0,
        nrOfWeeks =
          svs.tipset.models.gameDefinitions.hasWeekPicker() &&
            svs.tipset.models.weekPicker
            ? svs.tipset.models.weekPicker.getNumberOfWeeks()
            : 1,
        rowPrice = svs.tipset.models.betslipExpanded
          ? svs.tipset.models.betslipExpanded.get('amount')
          : 1;
      if (svs.tipset.models.play.get('isReduceMode')) {
        price +=
          svs.tipset.models.reduceFreeContainer.get('rows') === 0
            ? 1
            : svs.tipset.models.reduceFreeContainer.get('rows');
      } else if (system && system.type != 'SM') {
        price += parseInt(this.getRowPrice() * system.rows * nrOfRows, 10);
      } else {
        price += parseInt(this.getRowPrice() * nrOfRows, 10);
      }

      price *= nrOfWeeks;
      price *= rowPrice;

      if (sportkryssAmount > 0) {
        price += parseInt(sportkryssAmount, 10);
      }

      if (
        svs.tipset.models.bombenXperten &&
        svs.tipset.models.bombenXperten.get('hasXpertValues') &&
        svs.tipset.models.bombenXperten.get('systemSize')
      ) {
        price += svs.tipset.models.bombenXperten.get('systemSize');
      }

      return price;
    },

    getRowPrice: function() {
      return this.get('rowPrice');
    },

    resetBetslip: function() {
      this.update();
    },

    isPayable: function() {
      var isValidSystem =
        svs.tipset.models.systems &&
        svs.tipset.models.systems.isValidSystem(),
        isCorrectCoupon =
          svs.tipset.collections.matchlist &&
          svs.tipset.collections.matchlist.isCorrect(),
        nrOfRows = svs.tipset.collections.matchlist
          ? svs.tipset.collections.matchlist.getNrOfRows()
          : undefined,
        selectedRows = svs.tipset.models.reduceFreeContainer.get('rows'),
        maxRowNotExceeded = nrOfRows
          ? nrOfRows <= svs.tipset.models.gameDefinitions.get('maxSystemSize')
          : false,
        isSportkryssCorrect =
          svs.tipset.models.gameDefinitions.hasSportkryss() &&
            svs.tipset.models.sportkryss
            ? svs.tipset.models.sportkryss.get('isValid')
            : true,
        isReduceFreeRowAmountOK,
        hasEnoughRowsToReduce,
        isValidSelfservice = true;

      if (svs.tipset.models.play.get('isReduceMode')) {
        maxRowNotExceeded = true;
        isReduceFreeRowAmountOK =
          selectedRows >= svs.tipset.constants.MIN_ROWS_INPUT_REDUCE_FREE &&
          selectedRows <= svs.tipset.constants.MAX_ROWS_INPUT_REDUCE_FREE;
        hasEnoughRowsToReduce = selectedRows < nrOfRows;
      } else {
        isReduceFreeRowAmountOK = true;
        hasEnoughRowsToReduce = true;
      }

      if (
        svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService')
          ? svs.core.config.data.svsconfig.isSelfService
          : false
      ) {
        var amount = svs.utils.ns.isNamespace(
          'svs.tipset.models.betslipExpanded'
        )
          ? svs.tipset.models.betslipExpanded.get('amount')
          : 1;

        isValidSelfservice =
          nrOfRows * amount >= 2 || svs.tipset.models.systems.getCurrentSystem()
            ? true
            : false;
      }

      return (
        isValidSystem &&
        isCorrectCoupon &&
        maxRowNotExceeded &&
        isSportkryssCorrect &&
        isReduceFreeRowAmountOK &&
        hasEnoughRowsToReduce &&
        isValidSelfservice
      );
    },

    pay: function() {
      if (!svs.tipset.models.wager) {
        svs.tipset.models.wager = new svs.tipset.models.Wager();
      }
      if (svs.tipset.models.competition) {
        svs.tipset.models.competition.setIsPayingCompetition(false);
      }

      svs.tipset.models.wager.startPaying();
    },

    payCompetition: function() {
      if (!svs.tipset.models.wager) {
        svs.tipset.models.wager = new svs.tipset.models.Wager();
      }
      if (svs.tipset.models.competition) {
        svs.tipset.models.competition.setIsPayingCompetition(true);
      }
      svs.tipset.models.wager.startPaying();
    },

    getCouponPrice: function() {
      var sportkryssAmount =
        svs.tipset.models.gameDefinitions.hasSportkryss() &&
          svs.utils.ns.isNamespace('svs.tipset.models.sportkryss')
          ? svs.tipset.models.sportkryss.get('sportkryssAmount')
          : 0,
        bombenAmount =
          svs.tipset.models.bombenXperten &&
            svs.tipset.models.bombenXperten.get('systemSize')
            ? svs.tipset.models.bombenXperten.get('systemSize')
            : 0,
        totalAmount = this.get('price'),
        boardAmount =
          sportkryssAmount > 0 ? totalAmount - sportkryssAmount : totalAmount;

      return boardAmount - bombenAmount;
    },

    getIsInCompetitionMode: function() {
      return (
        svs.tipset.models.competition &&
        svs.tipset.models.competition.getCompetitionMode()
      );
    },

    getIsM64: function() {
      return (
        svs.tipset.collections.matchlist.getNrOfRows() ==
        svs.tipset.constants.M_SYSTEM.M_64
      );
    },

    getCurrentDrawNumber: function() {
      return svs.tipset.collections.draws.getCurrentDraw().get('drawNumber');
    },

    getIsNotMultipleWeeks: function() {
      var nrOfWeeksSelected =
        svs.tipset.models.gameDefinitions.hasWeekPicker() &&
          svs.tipset.models.weekPicker &&
          svs.tipset.models.weekPicker.getNumberOfWeeks()
          ? svs.tipset.models.weekPicker.getNumberOfWeeks()
          : 1;
      return nrOfWeeksSelected < 2;
    },

    destroy: function() {
      this.stopListening();
      svs.components.account_balance.off('change', this.setAccountBalance);
    }
  });
})(Backbone, _, svs);

 })(window);